import { useState } from "react";
import { Dot, Panel, Tag } from "@akaike/ui";
import { IconBolt, IconGoogle, IconLock } from "../components/icons";
import { useDocumentTitle } from "../lib/document-title";
import { signIn } from "./client";

// Full-screen sign-in, from the retired GRID CONTROL login mockup. Google OAuth is the
// only way in; the domain + invite gates run server-side, so a rejected account
// returns here with an error in the query string.
export function Login() {
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error_description") ?? params.get("error");
  const [busy, setBusy] = useState(false);
  useDocumentTitle("Sign in");

  const onSignIn = () => {
    setBusy(true);
    signIn.social({ provider: "google", callbackURL: "/", errorCallbackURL: "/login" });
  };

  return (
    <div className="login-body">
      <section className="hero">
        <div className="hero-content">
          <div className="hero-brand">
            <span className="glyph">
              <IconBolt />
            </span>
            <div className="col" style={{ gap: 2 }}>
              <span
                style={{
                  fontFamily: "var(--f-display)",
                  fontVariationSettings: "'wdth' 112,'wght' 800",
                  fontSize: 18,
                  letterSpacing: ".02em",
                  color: "var(--ink)",
                }}
              >
                qcom<b style={{ color: "var(--brand)" }}>·</b>scrape
              </span>
            </div>
          </div>

          <div className="hero-eyebrow">operator control plane</div>
          <div className="hero-wordmark">
            qcom<span className="dot-sep">·</span>scrape
          </div>
          <p className="hero-statement">
            Drive and watch q-commerce scrapers at national scale: inventory, brands, and the
            dark-store map.
          </p>

          <div className="hero-tags">
            <Tag>multi-platform</Tag>
            <Tag>quick-commerce coverage</Tag>
            <Tag>
              control plane <Dot tone="ok" style={{ width: 6, height: 6 }} />{" "}
              <span style={{ color: "var(--ok)" }}>healthy</span>
            </Tag>
            <Tag>single-tenant</Tag>
          </div>
        </div>

        <svg className="hero-spark" viewBox="0 0 900 90" preserveAspectRatio="none">
          <defs>
            <linearGradient id="spark-grad" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0" stopColor="var(--brand)" stopOpacity=".6" />
              <stop offset="1" stopColor="var(--brand)" stopOpacity="0" />
            </linearGradient>
          </defs>
          <polygon
            fill="url(#spark-grad)"
            points="0,90 0,70 60,62 120,68 180,55 240,60 300,48 360,52 420,40 480,44 540,34 600,38 660,28 720,32 780,22 840,26 900,18 900,90"
          />
          <polyline
            fill="none"
            stroke="var(--brand)"
            strokeWidth="2"
            strokeLinejoin="round"
            points="0,70 60,62 120,68 180,55 240,60 300,48 360,52 420,40 480,44 540,34 600,38 660,28 720,32 780,22 840,26 900,18"
          />
        </svg>
      </section>

      <section className="signin-pane">
        <Panel className="signin-card">
          <div className="signin-heading">Sign in</div>
          <div className="signin-sub">
            Continue to <b style={{ color: "var(--ink)" }}>qcom·scrape</b>.
          </div>

          {error && (
            <div className="signin-error">
              <IconLock />
              <span>{decodeURIComponent(error)}</span>
            </div>
          )}

          <button className="btn-google" type="button" onClick={onSignIn} disabled={busy}>
            <IconGoogle />
            {busy ? "Redirecting…" : "Continue with Google"}
          </button>

          <div className="access-note">
            <IconLock />
            Use your @akaiketech.com account · invite-only access
          </div>

          <p className="signin-smallprint">
            Access is provisioned by a superuser. If you can't get in, ask an administrator.
          </p>
        </Panel>
      </section>
    </div>
  );
}
